import { render, staticRenderFns } from "./shop_list.vue?vue&type=template&id=47ced350"
import script from "./shop_list.vue?vue&type=script&lang=js"
export * from "./shop_list.vue?vue&type=script&lang=js"
import style0 from "./shop_list.vue?vue&type=style&index=0&id=47ced350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports